import isEmpty from 'lodash/isEmpty';
import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import moment from 'moment';
import withConfig from 'config/withConfig';
import IconChevronDoubleRight from '@spothero/icons/chevron-double-right';
import Button from '@spothero/ui/button';
import Image from 'common/image/Image';
import {toggleInfoPanelView} from 'search/search-actions';

const DestinationInfoPanelDesktop = ({
    searchType,
    destination: {
        title,
        default_image: defaultImage,
        street_address: address,
        city,
        state,
        description,
        monthly_description: monthlyDescription,
        destination_info_title: infoPanelTitle,
        monthly_destination_info_title: monthlyInfoPanelTitle,
    },
    isMonthly,
    event,
    onHideInfoPanelClick,
    displayEventDateFormat,
}) => {
    const imgId = defaultImage ? defaultImage.object.public_id : null;
    const imgAlt = defaultImage ? defaultImage.object.alt_text : null;
    const eventStartsFormatted = event.starts
        ? moment(event.starts).format(displayEventDateFormat)
        : null;
    const displayDescription = !isEmpty(event.eventCustomDescription)
        ? event.eventCustomDescription
        : isMonthly && monthlyDescription
        ? monthlyDescription
        : description;
    let displayTitle = `${
        !isEmpty(event.eventTitle) ? event.eventTitle : title
    } ${isMonthly ? 'Monthly ' : ''}Parking Information`;

    if (isMonthly && !isEmpty(monthlyInfoPanelTitle)) {
        displayTitle = monthlyInfoPanelTitle;
    } else if (!isEmpty(infoPanelTitle)) {
        displayTitle = infoPanelTitle;
    }

    return (
        <div className="InfoPanel DestinationInfoPanel">
            <div className="InfoPanel-container">
                <div className="InfoPanel-title">
                    <Button
                        className="InfoPanel-hide"
                        color="secondary"
                        onClick={onHideInfoPanelClick}
                    >
                        <IconChevronDoubleRight />
                    </Button>
                    <h2 className="title">{unescape(displayTitle)}</h2>
                </div>
                {imgId && (
                    <Image
                        className="InfoPanel-image"
                        width={284}
                        height={200}
                        cloudinaryImageId={imgId}
                        alt={imgAlt}
                    />
                )}
                <div className="InfoPanel-content">
                    <h2 className="subtitle">
                        {address && <span>{unescape(address)}</span>}
                        {city && (
                            <span>
                                {address && ', '}
                                {city}
                            </span>
                        )}
                        {state && <span>, {state}</span>}
                    </h2>
                    {eventStartsFormatted && (
                        <h2 className="subtitle">{eventStartsFormatted}</h2>
                    )}
                    <div
                        className="description-info-text"
                        dangerouslySetInnerHTML={{__html: displayDescription}}
                    />
                </div>
            </div>
        </div>
    );
};

DestinationInfoPanelDesktop.propTypes = {
    searchType: PropTypes.string.isRequired,
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    event: PropTypes.object,
    onHideInfoPanelClick: PropTypes.func.isRequired,
    isMonthly: PropTypes.bool.isRequired,
    displayEventDateFormat: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
    onHideInfoPanelClick: toggleInfoPanelView,
};
const enhance = compose(
    withConfig(['displayEventDateFormat']),
    connect(
        null,
        mapDispatchToProps
    )
);

export default enhance(DestinationInfoPanelDesktop);
